import { LOAD_MACHINES_FROM_CACHE } from "../action";
import { machines } from "./initial-store";

const initialState = machines;

function machineReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_MACHINES_FROM_CACHE:
      return action.payload;
    default:
      return state;
  }
}

export default machineReducer;
